/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedMyDayRouteImport } from './routes/_authenticated/my-day'
import { Route as AuthenticatedInboxRouteImport } from './routes/_authenticated/inbox'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedWorkspaceWorkspaceIdIndexRouteImport } from './routes/_authenticated/workspace/$workspaceId/index'
import { Route as AuthenticatedWorkspaceWorkspaceIdSettingsRouteImport } from './routes/_authenticated/workspace/$workspaceId/settings'
import { Route as AuthenticatedWorkspaceWorkspaceIdNotesRouteImport } from './routes/_authenticated/workspace/$workspaceId/notes'
import { Route as AuthenticatedWorkspaceWorkspaceIdCalendarRouteImport } from './routes/_authenticated/workspace/$workspaceId/calendar'
import { Route as AuthenticatedWorkspaceWorkspaceIdProjectsIndexRouteImport } from './routes/_authenticated/workspace/$workspaceId/projects/index'
import { Route as AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRouteImport } from './routes/_authenticated/workspace/$workspaceId/projects/$projectId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMyDayRoute = AuthenticatedMyDayRouteImport.update({
  id: '/my-day',
  path: '/my-day',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWorkspaceWorkspaceIdIndexRoute =
  AuthenticatedWorkspaceWorkspaceIdIndexRouteImport.update({
    id: '/workspace/$workspaceId/',
    path: '/workspace/$workspaceId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspaceWorkspaceIdSettingsRoute =
  AuthenticatedWorkspaceWorkspaceIdSettingsRouteImport.update({
    id: '/workspace/$workspaceId/settings',
    path: '/workspace/$workspaceId/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspaceWorkspaceIdNotesRoute =
  AuthenticatedWorkspaceWorkspaceIdNotesRouteImport.update({
    id: '/workspace/$workspaceId/notes',
    path: '/workspace/$workspaceId/notes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspaceWorkspaceIdCalendarRoute =
  AuthenticatedWorkspaceWorkspaceIdCalendarRouteImport.update({
    id: '/workspace/$workspaceId/calendar',
    path: '/workspace/$workspaceId/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspaceWorkspaceIdProjectsIndexRoute =
  AuthenticatedWorkspaceWorkspaceIdProjectsIndexRouteImport.update({
    id: '/workspace/$workspaceId/projects/',
    path: '/workspace/$workspaceId/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRoute =
  AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRouteImport.update({
    id: '/workspace/$workspaceId/projects/$projectId',
    path: '/workspace/$workspaceId/projects/$projectId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/my-day': typeof AuthenticatedMyDayRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/workspace/$workspaceId/calendar': typeof AuthenticatedWorkspaceWorkspaceIdCalendarRoute
  '/workspace/$workspaceId/notes': typeof AuthenticatedWorkspaceWorkspaceIdNotesRoute
  '/workspace/$workspaceId/settings': typeof AuthenticatedWorkspaceWorkspaceIdSettingsRoute
  '/workspace/$workspaceId/': typeof AuthenticatedWorkspaceWorkspaceIdIndexRoute
  '/workspace/$workspaceId/projects/$projectId': typeof AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRoute
  '/workspace/$workspaceId/projects/': typeof AuthenticatedWorkspaceWorkspaceIdProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/my-day': typeof AuthenticatedMyDayRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/': typeof AuthenticatedIndexRoute
  '/workspace/$workspaceId/calendar': typeof AuthenticatedWorkspaceWorkspaceIdCalendarRoute
  '/workspace/$workspaceId/notes': typeof AuthenticatedWorkspaceWorkspaceIdNotesRoute
  '/workspace/$workspaceId/settings': typeof AuthenticatedWorkspaceWorkspaceIdSettingsRoute
  '/workspace/$workspaceId': typeof AuthenticatedWorkspaceWorkspaceIdIndexRoute
  '/workspace/$workspaceId/projects/$projectId': typeof AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRoute
  '/workspace/$workspaceId/projects': typeof AuthenticatedWorkspaceWorkspaceIdProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/calendar': typeof AuthenticatedCalendarRoute
  '/_authenticated/inbox': typeof AuthenticatedInboxRoute
  '/_authenticated/my-day': typeof AuthenticatedMyDayRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/workspace/$workspaceId/calendar': typeof AuthenticatedWorkspaceWorkspaceIdCalendarRoute
  '/_authenticated/workspace/$workspaceId/notes': typeof AuthenticatedWorkspaceWorkspaceIdNotesRoute
  '/_authenticated/workspace/$workspaceId/settings': typeof AuthenticatedWorkspaceWorkspaceIdSettingsRoute
  '/_authenticated/workspace/$workspaceId/': typeof AuthenticatedWorkspaceWorkspaceIdIndexRoute
  '/_authenticated/workspace/$workspaceId/projects/$projectId': typeof AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRoute
  '/_authenticated/workspace/$workspaceId/projects/': typeof AuthenticatedWorkspaceWorkspaceIdProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/calendar'
    | '/inbox'
    | '/my-day'
    | '/settings'
    | '/workspace/$workspaceId/calendar'
    | '/workspace/$workspaceId/notes'
    | '/workspace/$workspaceId/settings'
    | '/workspace/$workspaceId/'
    | '/workspace/$workspaceId/projects/$projectId'
    | '/workspace/$workspaceId/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/calendar'
    | '/inbox'
    | '/my-day'
    | '/settings'
    | '/'
    | '/workspace/$workspaceId/calendar'
    | '/workspace/$workspaceId/notes'
    | '/workspace/$workspaceId/settings'
    | '/workspace/$workspaceId'
    | '/workspace/$workspaceId/projects/$projectId'
    | '/workspace/$workspaceId/projects'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/calendar'
    | '/_authenticated/inbox'
    | '/_authenticated/my-day'
    | '/_authenticated/settings'
    | '/_authenticated/'
    | '/_authenticated/workspace/$workspaceId/calendar'
    | '/_authenticated/workspace/$workspaceId/notes'
    | '/_authenticated/workspace/$workspaceId/settings'
    | '/_authenticated/workspace/$workspaceId/'
    | '/_authenticated/workspace/$workspaceId/projects/$projectId'
    | '/_authenticated/workspace/$workspaceId/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-day': {
      id: '/_authenticated/my-day'
      path: '/my-day'
      fullPath: '/my-day'
      preLoaderRoute: typeof AuthenticatedMyDayRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inbox': {
      id: '/_authenticated/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthenticatedInboxRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar': {
      id: '/_authenticated/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspace/$workspaceId/': {
      id: '/_authenticated/workspace/$workspaceId/'
      path: '/workspace/$workspaceId'
      fullPath: '/workspace/$workspaceId/'
      preLoaderRoute: typeof AuthenticatedWorkspaceWorkspaceIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspace/$workspaceId/settings': {
      id: '/_authenticated/workspace/$workspaceId/settings'
      path: '/workspace/$workspaceId/settings'
      fullPath: '/workspace/$workspaceId/settings'
      preLoaderRoute: typeof AuthenticatedWorkspaceWorkspaceIdSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspace/$workspaceId/notes': {
      id: '/_authenticated/workspace/$workspaceId/notes'
      path: '/workspace/$workspaceId/notes'
      fullPath: '/workspace/$workspaceId/notes'
      preLoaderRoute: typeof AuthenticatedWorkspaceWorkspaceIdNotesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspace/$workspaceId/calendar': {
      id: '/_authenticated/workspace/$workspaceId/calendar'
      path: '/workspace/$workspaceId/calendar'
      fullPath: '/workspace/$workspaceId/calendar'
      preLoaderRoute: typeof AuthenticatedWorkspaceWorkspaceIdCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspace/$workspaceId/projects/': {
      id: '/_authenticated/workspace/$workspaceId/projects/'
      path: '/workspace/$workspaceId/projects'
      fullPath: '/workspace/$workspaceId/projects/'
      preLoaderRoute: typeof AuthenticatedWorkspaceWorkspaceIdProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspace/$workspaceId/projects/$projectId': {
      id: '/_authenticated/workspace/$workspaceId/projects/$projectId'
      path: '/workspace/$workspaceId/projects/$projectId'
      fullPath: '/workspace/$workspaceId/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCalendarRoute: typeof AuthenticatedCalendarRoute
  AuthenticatedInboxRoute: typeof AuthenticatedInboxRoute
  AuthenticatedMyDayRoute: typeof AuthenticatedMyDayRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedWorkspaceWorkspaceIdCalendarRoute: typeof AuthenticatedWorkspaceWorkspaceIdCalendarRoute
  AuthenticatedWorkspaceWorkspaceIdNotesRoute: typeof AuthenticatedWorkspaceWorkspaceIdNotesRoute
  AuthenticatedWorkspaceWorkspaceIdSettingsRoute: typeof AuthenticatedWorkspaceWorkspaceIdSettingsRoute
  AuthenticatedWorkspaceWorkspaceIdIndexRoute: typeof AuthenticatedWorkspaceWorkspaceIdIndexRoute
  AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRoute: typeof AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRoute
  AuthenticatedWorkspaceWorkspaceIdProjectsIndexRoute: typeof AuthenticatedWorkspaceWorkspaceIdProjectsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,
  AuthenticatedInboxRoute: AuthenticatedInboxRoute,
  AuthenticatedMyDayRoute: AuthenticatedMyDayRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedWorkspaceWorkspaceIdCalendarRoute:
    AuthenticatedWorkspaceWorkspaceIdCalendarRoute,
  AuthenticatedWorkspaceWorkspaceIdNotesRoute:
    AuthenticatedWorkspaceWorkspaceIdNotesRoute,
  AuthenticatedWorkspaceWorkspaceIdSettingsRoute:
    AuthenticatedWorkspaceWorkspaceIdSettingsRoute,
  AuthenticatedWorkspaceWorkspaceIdIndexRoute:
    AuthenticatedWorkspaceWorkspaceIdIndexRoute,
  AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRoute:
    AuthenticatedWorkspaceWorkspaceIdProjectsProjectIdRoute,
  AuthenticatedWorkspaceWorkspaceIdProjectsIndexRoute:
    AuthenticatedWorkspaceWorkspaceIdProjectsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
